import { useNavigate } from 'react-router-dom';
import { Icon } from '@antimatterhq/ui/components/icon';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@antimatterhq/ui/components/card';
import { Button } from '@antimatterhq/ui/components/button';
import { Text } from '@antimatterhq/ui/components/typography';

export type AddCustomDataSourceCardProps = {
  'data-testid'?: string;
};

export const AddCustomDataSourceCard: React.FC<
  AddCustomDataSourceCardProps
> = ({ 'data-testid': dataTestId = 'add-custom-datasource-card' }) => {
  const navigate = useNavigate();
  return (
    <Card
      className={'flex min-h-60 w-full flex-col px-4 py-4'}
      data-testid={dataTestId}
    >
      <CardHeader className="space-y-1 p-0">
        <Text
          size="lg"
          semiBold
          color="secondary"
          data-testid={`${dataTestId}-title`}
        >
          Custom datasource
        </Text>
      </CardHeader>

      <CardContent className="flex h-full w-full items-center justify-center">
        <Icon
          icon={'antimatterhq:custom-datasource'}
          className="mt-auto text-4xl text-blue-500"
          width={64}
          data-testid={`${dataTestId}-icon`}
        />
      </CardContent>

      <CardFooter className="mt-auto w-full px-0 py-0">
        <Button
          leftIcon="lucide:plus"
          className="w-full"
          onClick={() => {
            navigate('/configure/data-sources/add/source');
          }}
          data-testid={`${dataTestId}-button`}
        >
          Add custom datasource
        </Button>
      </CardFooter>
    </Card>
  );
};
